/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} UnfeaturedInputs */

const en_unfeatured = /** @type {(inputs: UnfeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unfeatured`)
};

const es_unfeatured = /** @type {(inputs: UnfeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin destacar`)
};

/**
* | output |
* | --- |
* | "Unfeatured" |
*
* @param {UnfeaturedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const unfeatured = /** @type {((inputs?: UnfeaturedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<UnfeaturedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_unfeatured(inputs)
	return es_unfeatured(inputs)
});